import type { IconData } from '@stacksjs/iconify-core'

export const moreHorizontalF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 6a3 3 0 1 1 0-6a3 3 0 0 1 0 6m14 0a3 3 0 1 1 0-6a3 3 0 0 1 0 6m-7 0a3 3 0 1 1 0-6a3 3 0 0 1 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default moreHorizontalF
